export const ALLERGIES_URL = '/api/v3/allergies/';
